import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { HandexInstance, HanjinInstance, LogenInstance, LotteInstance } from "../instance";
import { weekTotalState } from "../../stores/dashboard/weekTotalState";

// 고객사별 API 인스턴스 선택 함수
const getApiInstance = (company) => {
  const instances = {
    LOGEN: LogenInstance,
    LOTTE: LotteInstance,
    HANJIN: HanjinInstance,
    HANDEX: HandexInstance,
  };
  return instances[company] || null;
};

// TODO 월간 데이터 조회 API
export const useGetWeekChart = (setWeekData) => {
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setWeekTotal = useSetRecoilState(weekTotalState); // 월간 데이터

  // API 요청 함수
  const fetchData = async () => {
    const apiInstance = getApiInstance(login.company);
    if (!apiInstance) throw new Error("Invalid company");

    return apiInstance.post("/boardTotal", {
      api: "week",
      data: [{ bran_cd: login.branchCode }],
    });
  };

  return useMutation("getWeekChart", fetchData, {
    onSuccess: (data) => {
      if (data.result === "00") {
        setWeekData(data.data);
        const totalSum = data.data.reduce((totalSum, item) => {
          const itemSum = Array.isArray(item.count)
            ? item.count.reduce((sum, countStr) => sum + parseInt(countStr, 10), 0)
            : parseInt(item.count, 10);
          return totalSum + itemSum;
        }, 0);
        setWeekTotal(totalSum);
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });
};
